import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import {
  APP_ONLY_FEATURES,
  withTopicParticle,
  type AppOnlyFeatureKey,
} from '@/shared/constants/appOnlyFeatures';
import { ROUTE_PATHS } from '@/shared/constants/routes';
import { Link, useParams } from '@tanstack/react-router';

/**
 * M-13 A3 — 앱 전용 기능 주소로 직접 들어왔을 때의 전면 안내.
 * 404가 아니라 "여기서는 안 되고 앱에서 된다"와 돌아갈 곳을 함께 준다.
 */
export const AppOnlyPage = () => {
  const { feature } = useParams({ strict: false }) as { feature?: string };
  const label = APP_ONLY_FEATURES[feature as AppOnlyFeatureKey] ?? '이 기능';

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="flex w-full max-w-[420px] flex-col items-center gap-3 rounded-card border border-line bg-surface px-6 py-10 text-center">
        <Badge tone="app">앱 전용 기능</Badge>
        <h1 className="text-lg font-bold text-ink">
          이 기능은 앱에서 이용할 수 있어요
        </h1>
        <p className="text-[13px] leading-5 text-ink-4">
          {withTopicParticle(label)} 웹에서 제공하지 않습니다. 앱을 열어 이어서
          진행해 주세요.
        </p>
        <Button asChild className="mt-3 w-full">
          <Link to={ROUTE_PATHS.ACCOUNTS}>거래처로 돌아가기</Link>
        </Button>
      </div>
    </div>
  );
};
